// Visual status timeline (MyBookings user story 3.1). Derives 9 steps from the booking's
// independent status fields (status/deliveryStatus/returnStatus/depositStatus) rather than a
// single field, per Docs/requirements/jewelry_rental/MyBookings/mybookings.md §3.
export default function BookingTimeline({ booking }) {
  if (booking.status === 'cancelled') {
    return (
      <div className="d-flex align-items-center gap-2 text-danger">
        <span aria-hidden>✕</span>
        <strong>Booking Cancelled</strong>
      </div>
    );
  }

  const delivered = booking.deliveryStatus === 'DELIVERED';
  const outForDelivery = ['IN_TRANSIT', 'DELIVERED'].includes(booking.deliveryStatus);
  const prepared = ['PICKED_UP', 'IN_TRANSIT', 'DELIVERED'].includes(booking.deliveryStatus);
  const rentalStarted = delivered && new Date(booking.startDate) <= new Date();
  const returnScheduled = booking.returnStatus !== 'NOT_DUE';
  const returned = ['RECEIVED', 'INSPECTION_PENDING', 'COMPLETED'].includes(booking.returnStatus);
  const depositRefunded = booking.depositStatus === 'REFUNDED';

  const steps = [
    { key: 'requested', label: 'Booking Confirmed', done: true },
    { key: 'accepted', label: 'Owner Accepted', done: booking.status === 'confirmed' },
    { key: 'prepared', label: 'Jewellery Prepared', done: prepared },
    { key: 'outfordelivery', label: 'Out for Delivery', done: outForDelivery },
    { key: 'delivered', label: 'Delivered', done: delivered },
    { key: 'rental', label: 'Rental Period', done: rentalStarted },
    { key: 'returnscheduled', label: 'Return Scheduled', done: returnScheduled },
    { key: 'returned', label: 'Returned', done: returned },
    { key: 'depositrefunded', label: 'Security Deposit Refunded', done: depositRefunded }
  ];

  const currentIndex = steps.findIndex((s) => !s.done);

  return (
    <ol className="list-unstyled mb-0">
      {steps.map((step, i) => {
        const isCurrent = i === currentIndex;
        const icon = step.done ? '✓' : isCurrent ? '●' : '○';
        const colorClass = step.done ? 'text-success' : isCurrent ? 'text-primary fw-semibold' : 'text-muted';
        return (
          <li key={step.key} className={`d-flex align-items-center gap-2 py-1 ${colorClass}`}>
            <span aria-hidden style={{ width: '1.25rem', display: 'inline-block' }}>{icon}</span>
            <span>{step.label}</span>
          </li>
        );
      })}
    </ol>
  );
}
